import * as ast from '../../generated/ast.js';
import { checkForDuplicateAndRequiredProperties, getId, } from '../../common/utilities.js';
import { FRONTEND_PROPERTY_NAME } from '../../common/constants.js';
export function validateStarJson(starJson, accept) {
    // Get the parent Node to which this belongs. The full path to that is
    // StarJson => RichAssetStar => RichAsset => Node
    const parentNode = starJson?.$container?.$container?.$container;
    // Check for duplicate and required properties
    checkForDuplicateAndRequiredProperties({
        node: starJson,
        allProperties: starJson.properties,
        requiredProperties: [ast.TypeStaticProperty, ast.StarOptionsArrayProperty],
        parentNode,
        accept,
    });
}
export function validateStarOptionsArrayProperty(starOptionsArray, accept) {
    if (starOptionsArray.options.length > 10) {
        // Get the parent Node to which this belongs. The full path to that is
        // StarOptionsArray => StarJson => RichAssetStar => RichAsset => Node
        const parentNode = starOptionsArray?.$container?.$container?.$container
            ?.$container;
        const idField = getId(parentNode);
        accept('error', "Cannot have more than 10 items in the 'options' for star.", {
            node: starOptionsArray,
            data: {
                id: idField?.id?.value,
                nodeNumber: parentNode?.name,
                propertyName: FRONTEND_PROPERTY_NAME.RICH_ASSET_CONTENT,
            },
        });
    }
}
//# sourceMappingURL=star.js.map